import "./index.scss";

import InvitationTabContent from "@Pages/UsersPage/Tabs/InvitationTabContent";
import UsersTabContent from "@Pages/UsersPage/Tabs/UserTabContent";
import { inviteUsersListRequest } from "@Store/Invites/actions";
import {
  selectCurrentOrgId,
  selectCurrentOrganization,
} from "@Store/Organizations/selectors";
import { IOrganization, OrganizationId } from "@Store/Organizations/types";
import { useAppDispatch, useAppSelector } from "@hooks";
import MainComponent from "@src/MainComponent";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ModalInviteUser from "./ModalInviteUser";
import ModalOrganizationUser from "./ModalOrganizationUser";

const { TabPane } = Tabs;

const UsersPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const orgId: OrganizationId | undefined = useAppSelector(selectCurrentOrgId);
  const currentOrganization: IOrganization = useAppSelector(
    selectCurrentOrganization
  );

  useEffect(() => {
    orgId && dispatch(inviteUsersListRequest(orgId));
  }, [currentOrganization]);

  return (
    <MainComponent>
      <div className="app__organizationUserPage">
        <Tabs type="card">
          <TabPane key="users" tab={t("inviteUser.users")}>
            <UsersTabContent dispatch={dispatch} />
          </TabPane>
          <TabPane key="invitations" tab={t("inviteUser.invitations")}>
            <InvitationTabContent dispatch={dispatch} />
          </TabPane>
        </Tabs>
      </div>
      <ModalInviteUser />
      {/*<ModalDeleteUser />*/}
      {/*<ModalDeleteInviteUser />*/}
      {/*<ModalSendNotificationInviteUser />*/}
      <ModalOrganizationUser />
    </MainComponent>
  );
};

export default UsersPage;
